import React, { useMemo, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import * as XLSX from "xlsx";
import Button from "../../components/utils/Button";
import Table from "../../components/utils/Table";
import CardLayout from "../../components/utils/CardLayout";
import { useDispatch, useSelector } from "react-redux";
import reportActions from "../../redux/reports/actions";
import genericActions from "../../redux/generic/actions";
import { downloadExcelSampleFile } from "../../helpers/commonFunction";
const { getACode } = genericActions;
const { getrechargeBatchReports, resetMessage } = reportActions;

const RechargeBatchDetails = ({ selectedBatchId, onBack }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const { aCodeList } = useSelector(state => state.generic);
    const [searchItem, setSearchItem] = useState("");
    const today = new Date();
    const beforeTwoDays = new Date();
    beforeTwoDays.setDate(beforeTwoDays.getDate() - 2);
    const formatDate = (date) => date.toISOString().split("T")[0];
    const { rechargeBatchReports, rechargeBatchReportsLoading, } = useSelector((state) => state.reports)
    const { defaultCurrency } = useSelector((state) => state.auth);

    const { register, handleSubmit, reset, formState: { errors } } = useForm({
        mode: "onChange",
        defaultValues: {
            batchID: "",
            isBatchDetail: true,
        },
    });

    useEffect(() => {
        if (selectedBatchId) {
            dispatch(getrechargeBatchReports({
                batchID: selectedBatchId,
                isBatchDetail: true,
            }));
        }
    }, [selectedBatchId]);


    const columns = [
        { displayName: "Type", key: "BatchId" },
        { displayName: "Batch ID", key: "TransactionId" },
        { displayName: "Txn ID", key: "MobileNumber" },
        { displayName: "Serial Number", key: "SerialNumber" },
        { displayName: "MSISDN", key: "PlanName" },
        { displayName: "Status", key: "PlanAmount" },
        { displayName: "Description", key: "ChargedAmount" },
        { displayName: "Month", key: "ValidityDays" },
        { displayName: "RechargeDate", key: "RechargeDate" },
        { displayName: "Remarks", key: "remarks" },
      
    ];

    const filteredItems = useMemo(() => {
        return Array.isArray(rechargeBatchReports) && rechargeBatchReports.length > 0
            ? rechargeBatchReports.filter(item => {
                if (!searchItem) return true;
                return Object.values(item).some(val => typeof val === "string" && val.toLowerCase().includes(searchItem.toLowerCase()));
            })
            : [];
    }, [rechargeBatchReports, searchItem]);

    const rowData = useMemo(() => {
        return (filteredItems || []).map((item) => ({
            // TxnType: item?.TxnType == 26 ? 'eSIM' : 'pSIM',
            BatchId: item?.BatchID,
            TransactionId: item?.TransactionID,
            MobileNumber: item?.MobileNumber,
            SerialNumber: item?.SerialNumber,
            PlanName: item?.PlanName,
            PlanAmount: item?.PlanAmount,
            ChargedAmount: item?.ChargedAmount,
            ValidityDays: item?.ValidityDays,
            RechargeDate: item?.RechargeDate,
            remarks: item?.Remarks,

        }));
    }, [filteredItems]);

    const handleBack = () => {
        onBack();
    }

    const handleExportExcel = () => {
        const data = filteredItems.map(item => ({
            // "Type": item?.TxnType == 26 ? 'eSIM' : 'pSIM',
            "Batch ID": item["BatchID"],
            "Txn ID": item["TransactionID"],
            "Mobile Number": item["MobileNumber"],
            "Serial Number": item["SerialNumber"],
            "Plan Name": item["PlanName"],
            "Plan Amount": item["PlanAmount"],
            "Charged Amount": item["ChargedAmount"],
            "Validity Days": item["ValidityDays"],
            "Recharge Date": item["RechargeDate"],
            "Remarks": item["Remarks"],
        }));

        downloadExcelSampleFile(data, "recharge-batch-detail.xlsx");
    };

    return (
        <CardLayout
            title={<> Recharge Batch Details<span style={{ color: "#4b9b60" }}> :#{selectedBatchId}
            </span>
            </>
            }
            icon="ri-file-chart-line "
            rightContent={
                <div className="d-flex gap-2">
                    <Button
                        title="Back"
                        buttonType="button"
                        icon={<i className="ri-arrow-left-line me-1" />}
                        variant="primary"
                        style={{
                            padding: "5px 10px",
                        }}
                        onClick={() => handleBack()}
                    />
                    <Button
                        title="Excel"
                        buttonType="button"
                        variant="secondary"
                        onClick={handleExportExcel}
                        icon={<i className="ri-download-cloud-line me-2" />}
                    />
                </div>
            }
        >
            {/* Table */}
            <div className="mt-2">
                <Table
                    columns={columns}
                    data={rowData}
                    pagination
                    loading={rechargeBatchReportsLoading}
                    tableHeight="270px"
                />
            </div>


        </CardLayout>

    );
};

export default RechargeBatchDetails;

